var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.wallets'),"text":_vm.$t('wallets.description'),"name":"wallets","url":_vm.$listRoutes.wallets,"table":_vm.wallets,"filters":_vm.walletsFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }